import type { DateTime } from 'luxon'
import { parseDatetime } from './datetime'

/** Structural waypoint subset, independent of generated query types. */
type SiteTimesWaypoint = {
  scheduledArrivalTimeLocal?: string | null
  order?: { id: number; dateOfServiceLocal?: string | null } | null
}

export type AssignmentSiteTimes = {
  /** Scheduled arrival at the first order stop. */
  onsiteAt?: DateTime
  /** Pour time (date of service) of that order. */
  concreteAt?: DateTime
}

/**
 * Site-based times for orgs that skip the yard (`crew.assignmentOnsiteTimes`).
 * Yard stops carry no order, so the first stop with one is the job site.
 */
export const assignmentSiteTimes = (
  waypoints: readonly SiteTimesWaypoint[] | null | undefined,
): AssignmentSiteTimes => {
  const firstOrderStop = waypoints?.find((wp) => wp.order != null)
  if (!firstOrderStop) return {}
  return {
    onsiteAt: parseDatetime(firstOrderStop.scheduledArrivalTimeLocal),
    concreteAt: parseDatetime(firstOrderStop.order?.dateOfServiceLocal),
  }
}
